import React from 'react';
import { useGetPublisherConsentsQuery } from '../../../api/publisherApiSlice';
import VendorConsent from '../../metrics/VendorConsent';

const PublisherVendorConsent = ( { publisherId, startDate, endDate } ) => {
  const { data = [], isSuccess, isLoading, refetch } = useGetPublisherConsentsQuery({publisherId, startDate, endDate})
  return (
    <VendorConsent data={data} loaderProps={{isLoading, isSuccess, retry: refetch}}/>
  )
}

export default PublisherVendorConsent
